import { gsap } from "gsap";    
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const parallax = {
  init: function() {
    this.setParallax();
  },
  setParallax: () => {
    let mm = gsap.matchMedia();

    mm.add("(min-width: 992px)", () => {
      gsap.to(".text-with-image__image", {
        yPercent: -30,
        ease: "none",
        scrollTrigger: {
          trigger: '.parallax-container',
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }, 
      });
  
      gsap.to(".text-with-image__text", {
        yPercent: 30,
        ease: "none",
        scrollTrigger: {
          trigger: '.parallax-container',
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }, 
      });
    })
  }
}

export default parallax;